import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { includes } from 'ramda'
import { colors } from '@/styles'
import {
  ValueText,
  CollapsibleContainer,
  LabeledValue,
  LabelText
} from '@/features/Application/elements'
import formatCurrency from '@/utils/format-currency'
import SummaryContainer from '../summary-container.jsx'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  > :nth-child(even) {
    background: ${colors.background};
  }
  > * {
    border-bottom: 1px solid ${colors.grey88};
    padding: 12px;
  }
`

const Summary = ({ data = {}, title, defaultOpen = false, isLocked, isLoading }) => {
  const { t } = useTranslation()
  const { warnings = [] } = data ?? {}
  const getWarning = key => includes(key, warnings)
  return (
    <CollapsibleContainer title={title} defaultOpen={defaultOpen}>
      <Wrapper>
        <LabeledValue
          label={
            <LabelText>
              {t('l.application.view.total_remaining_balance.label', 'Total Balance Remaining:')}
            </LabelText>
          }
          value={
            <ValueText
              hasWarning={getWarning('remaining_balance')}
              type="small"
              isLocked={isLocked}
            >
              {formatCurrency(data?.remaining_balance, { hideCents: true }) ?? '-'}
            </ValueText>
          }
          isLoading={isLoading}
        />
        <LabeledValue
          label={
            <LabelText>
              {t('l.application.view.total_monthly_payments.label', 'Total Monthly Payments:')}
            </LabelText>
          }
          value={
            <ValueText hasWarning={getWarning('monthly_payments')} type="small" isLocked={isLocked}>
              {formatCurrency(data?.monthly_payments, { hideCents: true }) ?? '-'}
            </ValueText>
          }
          isLoading={isLoading}
        />
        <LabeledValue
          label={
            <LabelText>
              {t('l.application.view.total_credit_limit.label', 'Total Credit Limit:')}
            </LabelText>
          }
          value={
            <ValueText hasWarning={getWarning('credit_limit')} type="small" isLocked={isLocked}>
              {!!data?.credit_limit ? formatCurrency(data?.credit_limit, { hideCents: true }) : '-'}
            </ValueText>
          }
          isLoading={isLoading}
        />
        <LabeledValue
          label={
            <LabelText>
              {t('l.application.view.existing_late_payments.label', 'Existing Late Payments:')}
            </LabelText>
          }
          value={
            <ValueText hasWarning={getWarning('late_payments')} type="small" isLocked={isLocked}>
              {formatCurrency(data?.late_payments, { hideCents: true }) ?? '-'}
            </ValueText>
          }
          isLoading={isLoading}
        />
        <LabeledValue
          label={
            <LabelText>
              {t('l.application.view.average_days_to_pay.label', 'Average Days to Pay:')}
            </LabelText>
          }
          value={
            <SummaryContainer
              hasWarning={getWarning('average_days_paid')}
              value={data?.average_days_paid}
              rate={data?.rate}
              isLocked={isLocked}
            />
          }
          isLoading={isLoading}
        />
      </Wrapper>
    </CollapsibleContainer>
  )
}

export default Summary
